import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/founder/support")({
    component: RouteComponent,
});

function RouteComponent() {
    return <Outlet />;
}
